export const categories = [
  {
    id: "entertainment",
    name: "娱乐圈",
    icon: "ri-movie-2-line",
    desc: "艺人动态、影视综艺幕后与片场见闻，是投稿量最大的领域。",
    count: 4126,
  },
  {
    id: "creator",
    name: "网红圈",
    icon: "ri-live-line",
    desc: "直播与短视频生态里的翻车、合作与账号纠纷。",
    count: 2381,
  },
  {
    id: "business",
    name: "商界风闻",
    icon: "ri-briefcase-4-line",
    desc: "品牌公关、代言合作与商业纠纷的场内线索。",
    count: 1187,
  },
  {
    id: "workplace",
    name: "职场爆料",
    icon: "ri-building-2-line",
    desc: "行业内幕、团队管理与离职传闻的匿名记录。",
    count: 962,
  },
  {
    id: "campus",
    name: "校园见闻",
    icon: "ri-graduation-cap-line",
    desc: "教育机构、社团活动与校园事件的现场素材。",
    count: 574,
  },
  {
    id: "life",
    name: "生活圈",
    icon: "ri-cup-line",
    desc: "消费踩坑、服务体验与日常见闻的真实分享。",
    count: 530,
  },
];